// extracted by mini-css-extract-plugin
module.exports = {"TabbedNavigationItem":"TabbedNavigationItem_TabbedNavigationItem__whomS","active":"TabbedNavigationItem_active__6WnQs"};